import { createStyles, Divider, withStyles } from '@material-ui/core';
import React from 'react';
import { SECONDARY_COLOR } from '../../const/color-const';

const styles = createStyles(theme => ({
  root: {
    marginTop: theme.spacing(1.5),
    background: SECONDARY_COLOR,
  },
}));

const CommonDivider = (props) => {
  const { classes } = props;
  return (
    <Divider className={classes.root} />
  );
};

export default withStyles(styles)(CommonDivider);
